document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector<HTMLElement>(".header");
  if (header) {
    const isTransparent = header.dataset.transparentHome === "true";

    if (isTransparent) {
      document.body.classList.add("header-transparent-on-home");
    }
  }
});
